import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { onDisableWindowScroll, onEnableWindowScroll } from "../../utilities/helper";

const initialState = {
    value: [],
    currentSelection: [],
    show: false,
    status: "idle",
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk("suitcase/fetchCount", async (amount) => {
    // The value we return becomes the `fulfilled` action payload
});

export const suitcaseSlice = createSlice({
    name: "suitcase",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        addToSuitcase: (state, action) => {
            state.value = action.payload;
        },
        addToCurrentSelection: (state, action) => {
            state.currentSelection = action.payload;
        },
        addToShowSuitcase: (state, action) => {
            state.show = action.payload;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {},
});

export const { addToCurrentSelection, addToSuitcase, addToShowSuitcase } = suitcaseSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.buildMyHoliday.value)`
export const selectSuitcaseData = (state) => state.suitcase.value;
export const selectCurrentSelectionData = (state) => state.suitcase.currentSelection;
export const selectShowSuitcaseData = (state) => state.suitcase.show;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const handleShowSuitcase = () => (dispatch, getState) => {
    const currentValue = selectShowSuitcaseData(getState());
    // if (currentValue) {
    //     // document.body.style.overflowY = "";
    //     onEnableWindowScroll();
    // } else {
    //     onDisableWindowScroll();
    //     // document.body.style.overflowY = "hidden";
    // }
    dispatch(addToShowSuitcase(!currentValue));
};
export default suitcaseSlice.reducer;
